import 'regenerator-runtime/runtime';
import { SagaIterator } from 'redux-saga';
import { call, cancel, select, takeEvery } from 'redux-saga/effects';

import { GlobalAction, GlobalActions, GlobalPut } from '@ps20-frontend/shop-integration-redux';
import { App } from '@ps20-frontend/frontend-models';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { IAppState } from '../appState';

export function* provideStructuredRisikoortSaga(): SagaIterator {
  yield takeEvery(
    GlobalActions.STRUCTURED_RISIKOORT_REQUESTED,
    safeSaga(provideRisikoort, App.VWG),
  );
}

export function* provideRisikoort(action: GlobalAction<App>): SagaIterator {
  if (action.payload !== App.VWG) {
    return yield cancel();
  }
  const state: IAppState = yield select();
  const globalPut = GlobalPut.getInstance();
  yield call(
    globalPut.put,
    new GlobalActions().provideStructuredRisikoort(App.VWG, state.angebotsId, state.risikoort),
  );
}
